import React from 'react';
import styled from 'styled-components';
import { slideInFromRightWeighted } from '../../shared/component/Animation';
import { paperTextureSmall } from '../../shared/component/paperTexture';
import { useModalStore } from '../../shared/store/portal/modalStore';
import deleteIcon from '../../asset/icon/delete.png';
import { GuideModalPane } from './GuideModalContent';

/** WorkListPdfModal 퇴장(0.6s)과 맞춘 닫힘 대기 */
export const GUIDE_MODAL_CLOSE_MS = 700;

/** 현재 경로에 해당하는 가이드만 보여주는 데스크톱 모달. */
const GuideModal: React.FC = () => {
  const { isClosing, clearModal } = useModalStore();

  return (
    <Frame onClick={(e) => e.stopPropagation()} $isClosing={isClosing}>
      <GuideModalPane
        onClose={() => clearModal(GUIDE_MODAL_CLOSE_MS)}
        closeIcon={deleteIcon}
        closeHoverOpacity
      />
    </Frame>
  );
};

const Frame = styled.div<{ $isClosing: boolean }>`
  position: absolute;
  right: clamp(20px, 2vw, 30px);
  bottom: clamp(25px, 3vw, 50px);
  width: clamp(600px, 50vw, 600px);
  height: 88vh;
  max-height: 88vh;
  min-height: 0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
  transform: ${({ $isClosing }) => ($isClosing ? 'translateX(100%)' : 'translateX(0)')};
  transition: all 0.6s ease-out;
  ${paperTextureSmall}
  ${slideInFromRightWeighted}
`;

export default GuideModal;
